import { Fragment } from "react"
import { DashboardMyCredit } from "../../../../components/backgrounds/DashboardMyCredit"
import { SkeletonDahsboard } from "../../../../components/skeleton/skeletonDash"



export const SkeletonPayloginPage = () => {
    return (
        <Fragment>
            <DashboardMyCredit
                name={"Cargando"}
                balance={""}
                current={"2"}
                title={"Pagar mi cuota"}
                main={
                    <>
                        <div className="w-full h-full md:h-auto mt-10 rounded-3xl pb-32 md:pb-0 bg-white md:bg-transparent">
                            <div className="sm:grid justify-center">
                                <div className="sm:w-110 w-full px-12 py-10 bg-white md:shadow-lg rounded-3xl">
                                    <SkeletonDahsboard height={30} width={170} />
                                    <div className="py-4">
                                        <div className="flex justify-between gap-2 w-full pt-1 text-grayP">
                                            <SkeletonDahsboard height={20} width={100} />
                                            <SkeletonDahsboard height={20} width={70} />
                                        </div>
                                        <div className="flex justify-between gap-2 w-full pt-1 text-grayP">
                                            <SkeletonDahsboard height={20} width={110} />
                                            <SkeletonDahsboard height={20} width={50} />
                                        </div>
                                        <div className="flex justify-between gap-2 w-full pt-1 text-grayP">
                                            <SkeletonDahsboard height={20} width={100} />
                                            <SkeletonDahsboard height={20} width={60} />
                                        </div>
                                        <div className="flex justify-between gap-2 w-full pt-1 text-grayP">
                                            <SkeletonDahsboard height={20} width={100} />
                                            <SkeletonDahsboard height={20} width={60} />
                                        </div>
                                        <div className="flex justify-between gap-2 w-full pt-1 text-grayP">
                                            <SkeletonDahsboard height={20} width={110} />
                                            <SkeletonDahsboard height={20} width={50} />
                                        </div>
                                        <div className="flex justify-between gap-2 w-full pt-1 text-grayP">
                                            <SkeletonDahsboard height={20} width={30} />
                                            <SkeletonDahsboard height={20} width={55} />
                                        </div>
                                    </div>
                                    <div>
                                        <div className="flex gap-2 text-xl font-bold justify-between pt-4">
                                            <SkeletonDahsboard height={30} width={130} />
                                            <SkeletonDahsboard height={30} width={100} />
                                        </div>
                                    </div>
                                    <div>
                                        <SkeletonDahsboard height={20} width={200} />
                                    </div>
                                    <div className="flex gap-2 pt-8 sm:justify-center w-full">
                                        <div className="pb-2 sm:pb-0 w-full">
                                            <SkeletonDahsboard height={50} width={240} />
                                        </div>
                                        <div className="pb-2 sm:pb-0 w-full">
                                            <SkeletonDahsboard height={50} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }
            />
        </Fragment>
    )

}